import { useSelector } from 'react-redux';

import { domainConfig } from 'utils/domainConfig';
import { RootState } from '../storage/store';

export const useAmountOutdated = (agreementId?: number) => {
  const { isRo } = domainConfig;
  const { contracts } = useSelector((state: RootState) => state.contracts);

  const matchingAgreement = contracts?.find(
    ({ sourceContractId }) => sourceContractId === agreementId
  );

  return isRo && matchingAgreement?.amountOutdated === true;
};
